import { Log } from '../../AuxillaryService/Log';
import { moment } from '../../../vendor/moment';

('use strict');

let schedulerActions = [];
let schedulerNextRun = 0;

/**
 * @class
 */
class SchedulerItem {
    constructor() {
        this.Name = null;
        this.Callback = null;
        this.Parameters = null;
        this.Frequency = null;
        this.StopAt = null;

        this.Interval = null;
        this.NextExecution = moment();
        this.LastExecution;

        this.Active = true;
        this.ExecuteOnResume = false;
    }

    /**
     * Assigns name to the Scheduler
     * @param {string} name
     * @returns {SchedulerItem}
     */
    Called(name) {
        this.Name = name;

        return this;
    }

    /**
     * Assigns an action/callback to the Scheduler
     * @param {actionCallback} action
     * @returns {SchedulerItem}
     */
    HasAction(action) {
        this.Callback = action;

        return this;
    }

    /**
     * Assigns parameters to the Scheduler
     * @returns {SchedulerItem}
     */
    WithParameters() {
        this.Parameters = [];

        for (var i = 0; i < arguments.length; i++) {
            this.Parameters.push(arguments[i]);
        }

        return this;
    }

    /**
     * Assigns time interval for scheduler to run in
     * @param {number} interval
     * @param {string} type
     * @returns {SchedulerItem}
     */
    RunEvery(interval, type) {
        switch (type) {
            case 'millisecond':
            case 'milliseconds':
            case 'ms':
                this.Interval = interval;
                break;
            case 'second':
            case 'seconds':
            case 's':
            case 'ss':
                this.Interval = interval * 1000;
                break;
            case 'minute':
            case 'minutes':
            case 'm':
            case 'mi':
                this.Interval = interval * 60000;
                break;
            case 'hour':
            case 'hours':
            case 'h':
            case 'hh':
                this.Interval = interval * 3600000;
                break;
            case 'day':
            case 'days':
            case 'd':
            case 'dd':
                this.Interval = interval * 86400000;
                break;
        }

        if (typeof this.NextExecution === 'undefined') {
            this.NextExecution = moment().add(interval, 'milliseconds');
        }

        return this;
    }

    Starting(from) {
        this.NextExecution = Scheduler.Normalize(from);
        return this;
    }

    Until(until) {
        if (typeof until === 'undefined') {
            this.StopAt = moment();
        } else {
            this.StopAt = Scheduler.Normalize(until);
        }

        return this;
    }

    Execute() {
        if (this.Active) {
            try {
                this.Callback.apply(null, this.Parameters);
            } catch (callbackError) {
                setTimeout(function () {
                    // throw exception outside of scheduler so it does not
                    // affect functionality of all the other schedulers
                    throw callbackError;
                }, 100);
            }
        } else {
            // The Action should have ran, make sure it does when resumed.
            this.ExecuteOnResume = true;
        }
    }

    /**
     * @param {*} from
     * @returns {number} Unix timestamp in milliseconds
     */
    MoveNext(from) {
        if (typeof from === 'undefined') {
            from = moment();
        } else {
            from = Scheduler.Normalize(from);
        }

        this.NextExecution = from.add(this.Interval, 'milliseconds');

        if (
            null == this.Interval || //don't re-schedule if no interval is set!
            (typeof this.StopAt !== 'undefined' &&
                null !== this.StopAt &&
                this.NextExecution.valueOf() >= this.StopAt)
        ) {
            Scheduler.Delete(this.Name);

            return 9007199254740991; //Number.MAX_SAFE_INTEGER
        }

        return this.NextExecution.valueOf();
    }

    Pause() {
        this.Active = false;

        return this;
    }

    Resume() {
        this.Active = true;
        if (this.ExecuteOnResume) {
            this.ExecuteOnResume = false;
            this.MoveNext();
            this.Execute();
        }

        return this;
    }
}

const Scheduler = {};

Scheduler.Log = function (message) {
    Log.Info('Scheduler: ' + message, null, __fileline);
};

Scheduler.New = function () {
    var newSched = new SchedulerItem();
    schedulerActions.push(newSched);

    return newSched;
};

Scheduler.All = function () {
    return schedulerActions;
};

Scheduler.Delete = function (name) {
    var newActions = [];

    for (var i = 0; i < schedulerActions.length; ++i) {
        if (schedulerActions[i].Name != name) {
            newActions.push(schedulerActions[i]);
        }
    }

    schedulerActions = newActions;
};

Scheduler.RunAsync = function () {
    var scheduler_fx = function () {
        var nextRun = Scheduler.Run();

        var msUntilNextRun = nextRun - Date.now();

        setTimeout(
            scheduler_fx,
            msUntilNextRun <= 0 || msUntilNextRun > 1000 ? 1000 : msUntilNextRun
        );
    };

    setTimeout(scheduler_fx, 1);
};

Scheduler.Run = function () {
    var dtNow = Date.now();

    var nextRun = 9007199254740991; //Number.MAX_SAFE_INTEGER
    var currNextRun = null;
    var toExec = [];

    for (let i = 0; i < schedulerActions.length; ++i) {
        var a = schedulerActions[i];
        if (typeof a.NextExecution !== 'undefined') {
            if (a.NextExecution.valueOf() <= dtNow) {
                toExec.push(a);
                currNextRun = a.MoveNext();
            } else {
                currNextRun = a.NextExecution.valueOf();
            }

            if (currNextRun < nextRun) {
                nextRun = currNextRun;
            }
        }
    }

    schedulerNextRun = nextRun === 9007199254740991 ? 0 : nextRun;

    for (let i = 0; i < toExec.length; ++i) {
        toExec[i].Execute();
    }

    return schedulerNextRun;
};

Scheduler.NextRun = function () {
    return moment(schedulerNextRun);
};

/**
 * Ensures Scheduler receives a moment or undefined.  Converts Date and type
 * unknown objects into moments
 * @param {Moment|undefined} time
 * @returns {Moment|undefined}
 */
Scheduler.Normalize = function (time) {
    if (typeof time === 'undefined') {
        return;
    } else if (typeof time === 'string') {
        time = moment(time);
    } else if (time instanceof Date) {
        Log.Warning(
            'Date object passed to Scheduler.Normalize function, may result in incorrect scheduling',
            null,
            __fileline,
            this
        );
        time = moment(time);
    } else if (!moment.isMoment(time)) {
        Log.Error(
            'Unknown type provided to the Scheduler.Normalize function.  Returning now moment',
            null,
            __fileline,
            time
        );
        time = moment();
    }

    return time;
};

export { Scheduler, SchedulerItem };

/**
 * Callback for Scheduler action.
 * @callback actionCallback
 * @param {...*} parameter
 */
